module.exports = __webpack_public_path__ + "img/job_list.073d1a18.png";